import type React from 'react';
import { useCategoryFilterPopoverExit } from './useCategoryFilterPopoverExit';

type CategoryFilterPopoverExitProps = {
    /** The filter's own open state; an unmount while it is still open is not an exit. */
    isOpen: boolean;
    /** Called once the popover's content unmounts after the filter closed. */
    onExited?: () => void;
};

/**
 * Rendered inside the category filter's popover, so it unmounts only when the
 * popover has finished closing, after its exit animation. That is when
 * react-aria's focus scope puts focus back where it was before `F3` (a grid
 * tile, a cart line). While the popover is still mounted, its focus scope
 * pulls any focus move back inside, so sending focus home from
 * `onOpenChange(false)` did nothing (found by the browser suite,
 * bos-seller#63). Sending it from here wins: react-aria only restores focus
 * that is still on `body`.
 */
export const CategoryFilterPopoverExit: React.FC<
    CategoryFilterPopoverExitProps
> = ({ isOpen, onExited }) => {
    useCategoryFilterPopoverExit(isOpen, onExited);
    return null;
};
